/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candidate_Profile_Calendar_Sync_Subtitle_P2Inputs */

const en_candidate_profile_calendar_sync_subtitle_p2 = /** @type {(inputs: Candidate_Profile_Calendar_Sync_Subtitle_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In addition, ICS files can be downloaded separately next to each individual appointment.`)
};

const de_candidate_profile_calendar_sync_subtitle_p2 = /** @type {(inputs: Candidate_Profile_Calendar_Sync_Subtitle_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neben jedem einzelnen Termin lassen sich ICS-Dateien gesondert herunterladen.`)
};

/**
* | output |
* | --- |
* | "In addition, ICS files can be downloaded separately next to each individual appointment." |
*
* @param {Candidate_Profile_Calendar_Sync_Subtitle_P2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const candidate_profile_calendar_sync_subtitle_p2 = /** @type {((inputs?: Candidate_Profile_Calendar_Sync_Subtitle_P2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candidate_Profile_Calendar_Sync_Subtitle_P2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_candidate_profile_calendar_sync_subtitle_p2(inputs)
	return en_candidate_profile_calendar_sync_subtitle_p2(inputs)
});